import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../utils/seo';
import content from '../content/siteContent.json';

const Home = () => {
  const { home, header } = content;
  const contactEmail = header?.contactEmail || 'hello@takenostudio.dev';

  useEffect(() => {
    setPageMeta({ title: home.meta.title, description: home.meta.description });
  }, []);

  return (
    <div className="page">
      <section className="hero">
        <div className="scanline" />
        <div className="hero__content">
          <p className="hero__eyebrow">{home.hero.eyebrow}</p>
          <h1 className="hero__title">{home.hero.title}</h1>
          <p className="hero__subtitle">
            {home.hero.subtitle.split('\n')[0]}<br />
            {home.hero.subtitle.split('\n')[1]}
          </p>
          <div className="hero__cta">
            <Link to="/services" className="btn btn-primary">{home.hero.ctaPrimary}</Link>
            <a className="btn btn-ghost" href={`mailto:${contactEmail}`}>{home.hero.ctaSecondary}</a>
          </div>
        </div>
        <div className="hero__meme">
          <div className="crt-card">
            <span className="pixel-badge">{home.memeCard.badge}</span>
            <p>{home.memeCard.line1}</p>
            <p className="small">{home.memeCard.line2}</p>
            <div className="blink">{home.memeCard.cursor}</div>
          </div>
        </div>
      </section>

      <section className="grid">
        <div className="section-title">
          <p className="eyebrow">{home.edge.eyebrow}</p>
          <h2>{home.edge.title}</h2>
          <p className="section-lead">{home.edge.lead}</p>
        </div>
        <div className="card-grid">
          {home.edge.items.map((item) => (
            <article className="card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="grid services-preview">
        <div className="section-title">
          <p className="eyebrow">{home.releases.eyebrow}</p>
          <h2>{home.releases.title}</h2>
          <p className="section-lead">{home.releases.lead}</p>
        </div>
        <div className="card-grid">
          {home.releases.list.map((item) => (
            <article className="card card--accent" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
        <div className="cta-row">
          <Link to={home.releases.ctaPrimary.to} className="btn btn-primary">{home.releases.ctaPrimary.label}</Link>
          <Link to={home.releases.ctaSecondary.to} className="btn btn-ghost">{home.releases.ctaSecondary.label}</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
